// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3WZSg","title":"Header_title__2Tdqd","login":"Header_login__2juny","loading":"Header_loading__3Phzv","loaded":"Header_loaded__3-oNo"};